module.exports = __webpack_public_path__ + "static/media/ic-docs.ada7875b.svg";